export enum UserGroupServiceName {
  ANALYTICS = 'analytics'
}

export type UserGroupServiceAvailability = {
  name: UserGroupServiceName,
  active: boolean
  activation_date: string
  deactivation_date: string
}